const CDN_URL = process.env.CDN_URL;
const LOGO_URL = process.env.LOGO_URL;
const API_URL = process.env.API_URL;
const RESTRO_URL = process.env.RESTRO_URL;
export { LOGO_URL, CDN_URL, API_URL, RESTRO_URL };
